




























import Vue from "vue";
import { Component } from "vue-property-decorator";
import PhotoListResponse from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/PhotoGalleryModels/PhotoListResponse";
import WsResponseModel from "../../../api/dataSource/api/SchemaBuilderServer/Models/WsResponseModel";

@Component
export default class PageAlbumComponent extends Vue {
  photoResponse: WsResponseModel<PhotoListResponse> = null;

  mounted() {
    this.$api.PhotoGalleryService.GetPhotoListEvent.once(
      this.onGetPhotoList.bind(this)
    );
    this.$api.PhotoGalleryService.GetPhotoList({
      AlbumId: Number(this.$route.params.id)
    });
  }
  onGetPhotoList(response: WsResponseModel<PhotoListResponse>) {
    this.photoResponse = response;
        if(response.Value && response.Value.Album)
          this.$meta.setTitle(response.Value.Album.Name);
  }
}
